<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/h9tl6F/tc-custom/9781426833212.jpg?1705766094954" alt="This image is the cover for the book Disrobed and Dishonored, Undone!"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Disrobed and Dishonored, Undone!
      </h1>
      <p class="bookDescription body article font2">
        <p>Hidden behind a mask, Jonathan Kirkland, Lord Redcliffe, has disguised himself as a highwayman to win a wager: to collect kisses from the first five women who pass. With only one kiss left, victory seems easy...until he encounters Miss Sarah Tatton, who has fled on horseback to escape her vile fianc?.Distraught and desperate, the last thing Sarah needs is to run straight into the arms of a highwayman. But his heart-stopping kiss gives Sarah an idea--to lose her virginity in order to break her engagement. And the surprisingly gentlemanlike thief is just the man to teach her the art of love...at least enough to pretend that she has lost her virtue.<br/><br/>But as Jonathan and Sarah's passion grows, all pretense must come to an end...</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Louise Allen
      </h2>
      
      <p class="authorDescription body article">Louise Allen has been immersing herself in history for as long as she can remember. She finds landscapes and places evoke powerful images of the past - Venice, Burgundy and the Greek islands are favourite destinations. Louise lives on the Norfolk coast. She spends her spare time gardening, researching family history or travelling in search of inspiration. Please visit Louise's website &ndash; www.louiseallenregency.co.uk, or find her on Twitter @LouiseRegency and on Facebook.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?31572cb2